import { JSX } from "react/jsx-runtime"

import IntrinsicElements = JSX.IntrinsicElements

const editorAllowedTags: (keyof IntrinsicElements)[] = [
    "p",
    "span",
    "strong",
    "a",
    "b",
    "u",
    "i",
    "em",
    "ul",
    "ol",
    "li",
    "br"
]

export default { editorAllowedTags }
